import React, { useEffect, useState } from "react";

export default function QuizGoogleSheet({ sheetName }) {
  const [questions, setQuestions] = useState([]);
  const [current, setCurrent] = useState(0);
  const [selected, setSelected] = useState(null);
  const [score, setScore] = useState(0);
  const [loading, setLoading] = useState(true);

  const sheetId = "1tS23XjQpdM_Xz7dDd8YT5hgpVJ09mbq5zSX2azymcWM";

  const url = `https://opensheet.elk.sh/${sheetId}/${sheetName}`;

  useEffect(() => {
    setLoading(true);
    fetch(url)
      .then((res) => res.json())
      .then((data) => {
        setQuestions(data);
        setCurrent(0);
        setSelected(null);
        setScore(0);
        setLoading(false);
      })
      .catch((err) => console.error("Error loading sheet:", err));
  }, [sheetName]);

  if (loading) return <p>Loading {sheetName} quiz...</p>;
  if (!questions.length) return <p>No questions found for sheet "{sheetName}"</p>;

  const q = questions[current];

  const options = [
    { label: "A", text: q.optionA },
    { label: "B", text: q.optionB },
    { label: "C", text: q.optionC },
    { label: "D", text: q.optionD },
  ];

  const handleSelect = (ans) => {
    if (selected) return;
    setSelected(ans);

    if (ans === q.correct) {
      setScore(score + 1);
    }
  };

  const handleNext = () => {
    if (current === questions.length - 1) {
      alert(`Finished! Score: ${score}/${questions.length}`);
    } else {
      setCurrent(current + 1);
      setSelected(null);
    }
  };

  return (
    <div style={styles.box}>
      <h2>{sheetName.toUpperCase()} Quiz</h2>

      <h3>{current + 1}. {q.question}</h3>

      {options.map((op) => (
        <button
          key={op.label}
          onClick={() => handleSelect(op.label)}
          style={{
            ...styles.option,
            ...(selected &&
              (op.label === q.correct
                ? styles.correct
                : selected === op.label
                ? styles.wrong
                : {})),
          }}
        >
          {op.label}. {op.text}
        </button>
      ))}

      <button
        onClick={handleNext}
        disabled={!selected}
        style={{
          ...styles.next,
          background: selected ? "#2563eb" : "#9ca3af",
        }}
      >
        {current === questions.length - 1 ? "Finish" : "Next"}
      </button>
    </div>
  );
}

const styles = {
  box: {
    background: "#fff",
    padding: "20px",
    borderRadius: "10px",
    boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
    textAlign: "left",
  },
  option: {
    width: "100%",
    padding: "12px",
    marginBottom: "10px",
    borderRadius: "8px",
    border: "1px solid #ccc",
    fontSize: "16px",
    cursor: "pointer",
    textAlign: "left",
  },
  correct: {
    background: "#d4fcdc",
    borderColor: "#10b981",
  },
  wrong: {
    background: "#ffe0e0",
    borderColor: "#ef4444",
  },
  next: {
    width: "100%",
    padding: "12px",
    borderRadius: "8px",
    border: "none",
    color: "#fff",
    marginTop: "10px",
    cursor: "pointer",
  },
};
